
	import {
		Component,
		Vue,
		Prop,
		Watch,
		Emit,
		Mixins
    } from "vue-property-decorator";
    import { Getter, namespace } from "vuex-class";
    import AreaNotesTable from "@/components/area-notes/AreaNotesTable.vue";
    import { AreaNote } from "@/store/area-notes/types";
    import { FeaturesList } from "@/store/types";
    import { get } from "lodash";

    const SiteMonitor = namespace("siteMonitor");
    const AreaNotes = namespace("areaNotes");
    
    @Component({
        components: {
            "area-notes-table": AreaNotesTable
        }
    })
	export default class AcknowledgeAreaNotesModal extends Vue {
        @Getter("getFeaturesList") featuresList: FeaturesList;
        @AreaNotes.Getter getAreaNotes: AreaNote[];

        private showDialog: boolean = false;

        public async created() {
            this.showDialog = false;
        }

        private isAcknowledgeAreaNotesEnabled(): boolean {
		    return get(this.featuresList, ["Alarms", "SiteMonitor", "RequireAreaNotesAcknowledgement"], false);
	    }
        
        @Watch("getAreaNotes")
        public loadAreaNotesToAcknowledge(value: AreaNote[], oldValue: AreaNote[]): void {
            if (JSON.stringify(value) !== JSON.stringify(oldValue) ) {
                const numberOfNotesToAcknowledge: number = 
                    this.getAreaNotes.filter(note => note.requiresAcknowledgement === true).length;
                
                if (this.isAcknowledgeAreaNotesEnabled() && numberOfNotesToAcknowledge > 0) {
                    // Check if the feature to show the Notes to be Acknowledged is on
                    this.showDialog = true;
                }
            }
        }    
    }
